export default __webpack_public_path__ + "static/logo_white-cd9bde13029f3079d1de5a12658a427a.png";